/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Divyesh Rathod",
  title: "Hi, I'm Divyesh Rathod",
  subTitle: emoji(
    "Designing scalable systems where software meets intelligence is what drives me. I am a Software Engineer with a strong focus on machine learning, delivering data-driven solutions through clear communication, teamwork, and disciplined execution asap. Open to internships and co-op for Summer 2026"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1XZxWuoALjXtRTZ07XuXGyaFqj9g0paMh/view?usp=sharing", // Set to empty to hide the button
  resumeDownloadLink:
    "https://drive.google.com/uc?export=download&id=1XZxWuoALjXtRTZ07XuXGyaFqj9g0paMh",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/divyesh-rathod",
  linkedin: "https://www.linkedin.com/in/divyesh-rathod-developer/",
  gmail: "divyeshrathod096@gmail,com",
  leetcode: "https://leetcode.com/u/FroznFlames/",
  kaggle: "https://www.kaggle.com/divyeshrathod",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia

  display: true // Set true to display this section, defaults to false
};

// Skills Section

const softwareSkills = [
  // Languages
  {skillName: "C++", fontAwesomeClassname: "fas fa-code"},
  {skillName: "Python", fontAwesomeClassname: "fab fa-python"},
  {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
  {skillName: "TypeScript", fontAwesomeClassname: "fas fa-file-code"},

  // Backend + data + tooling
  {skillName: "Node.js", fontAwesomeClassname: "fab fa-node"},
  {skillName: "Express", fontAwesomeClassname: "fas fa-server"},
  {skillName: "FastAPI", fontAwesomeClassname: "fas fa-bolt"},
  {skillName: "Django", fontAwesomeClassname: "fas fa-leaf"},
  {skillName: "PostgreSQL", fontAwesomeClassname: "fas fa-database"},
  {skillName: "Prisma", fontAwesomeClassname: "fas fa-project-diagram"},
  {skillName: "Sequelize", fontAwesomeClassname: "fas fa-layer-group"},
  {skillName: "Postman", fontAwesomeClassname: "fas fa-paper-plane"},
  {skillName: "Playwright", fontAwesomeClassname: "fas fa-clipboard-check"},
  {skillName: "BeautifulSoup", fontAwesomeClassname: "fas fa-search"},

  // ML / data science
  {skillName: "PyTorch", fontAwesomeClassname: "fas fa-fire"},
  {skillName: "pandas", fontAwesomeClassname: "fas fa-chart-bar"},
  {skillName: "scikit-learn", fontAwesomeClassname: "fas fa-cogs"},
  {skillName: "matplotlib", fontAwesomeClassname: "fas fa-chart-line"},
  {skillName: "Hugging Face", fontAwesomeClassname: "fas fa-robot"},
  {skillName: "LangChain", fontAwesomeClassname: "fas fa-link"},
  {skillName: "NLTK", fontAwesomeClassname: "fas fa-book"},
  {skillName: "spaCy", fontAwesomeClassname: "fas fa-comments"},

  // Frontend
  {skillName: "HTML5", fontAwesomeClassname: "fab fa-html5"},
  {skillName: "CSS3", fontAwesomeClassname: "fab fa-css3-alt"},
  {skillName: "Tailwind CSS", fontAwesomeClassname: "fas fa-feather-alt"},
  {skillName: "React", fontAwesomeClassname: "fab fa-react"},
  {skillName: "Redux", fontAwesomeClassname: "fas fa-code-branch"},
  {skillName: "Redux Toolkit", fontAwesomeClassname: "fas fa-sitemap"},

  // Cloud / DevOps
  {skillName: "AWS", fontAwesomeClassname: "fab fa-aws"},
  {skillName: "Docker", fontAwesomeClassname: "fab fa-docker"},
  {skillName: "Linux", fontAwesomeClassname: "fab fa-linux"},
  {skillName: "GitHub", fontAwesomeClassname: "fab fa-github"},
  {skillName: "npm", fontAwesomeClassname: "fab fa-npm"},

  // Concepts
  {skillName: "OOP", fontAwesomeClassname: "fas fa-cubes"}
];

const skillsSection = {
  softwareSkills,
  sections: [
    {
      title: "What do I do",
      subTitle:
        "Full-Stack Developer | Building Intelligent, Data-Driven Systems",
      skills: [
        emoji(
          "⚡Deliver Full-Stack Solutions: Building end-to-end applications with modern frontend and backend frameworks, secure APIs, and scalable cloud infrastructure"
        ),
        emoji(
          "⚡Integrate Intelligent Systems: Embedding ML models, NLP pipelines, and recommendation engines into production-ready software"
        ),
        emoji(
          "⚡Drive Performance & Efficiency: Optimizing systems with async workflows, batching, and efficient data structures for speed and reliability"
        ),
        emoji(
          "⚡ Engineer with Best Practices: Applying TDD, clean architecture, and system design principles to create maintainable, production-quality solutions"
        )
      ],
      softwareSkills
    }
    // {
    //   subTitle:
    //     "ML ENGINEER FOCUSED ON BUILDING PRACTICAL, DATA-DRIVEN SYSTEMS",
    //   skills: [
    //     emoji(
    //       "⚡ Integrate machine learning models into production software systems"
    //     ),
    //     emoji(
    //       "⚡ Build and deploy NLP pipelines, embeddings, and recommendation engines"
    //     ),
    //     emoji(
    //       "⚡Implement RAG-style backends, similarity search, and neural reranking"
    //     ),
    //     emoji(
    //       "⚡Optimize inference performance using async I/O, batching, and efficient data structures"
    //     )
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "python",
    //       fontAwesomeClassname: "fab fa-python"
    //     }
    //   ]
    // }
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Carleton University",
      logo: require("./assets/images/cu102.png"),
      subHeader: "MEng in Software Engineering",
      duration: "September 2024 - December 2026",
      desc: "Graduate student with strong foundations in software design, systems, and security. Serving as Head Teaching Assistant for COMP 3007 – Programming Paradigms with ownership of TA coordination, grading workflows, and grade releases. Previously supported Abstract Data Structures and Algorithms, helping students develop strong algorithmic reasoning. Completed advanced coursework in Secure Systems, Agile and Test-Driven Development, Engineering Communication, and Data Analysis.",
      descBullets: [
        "Secure Systems: SSL/TLS, networking fundamentals, IP protocols, and security best practices",
        "Agile & TDD: Mockito-driven unit and integration testing",
        "Engineering Communication: technical writing, presentations, and stakeholder communication",
        "Data Analysis: data-driven problem solving and analytical thinking"
      ]
    },
    {
      schoolName: "Vyavasayi Vidya Pratishthan Engineering College",
      logo: require("./assets/images/vvp101.png"),
      subHeader: "B.Tech. in Information Technology",
      duration: "September 2019 - April 2023",
      desc: "I bring a strong foundation in software engineering principles, including Object-Oriented Programming, Data Structures, and Database Management, developed through rigorous university coursework. I have practical experience in building web and mobile applications using modern development practices, along with foundational exposure to AI, Machine Learning, and Data Mining through academic projects. This is supported by a consistent academic performance with a CGPA of 8.70."
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Almighty Infotech",
      companylogo: require("./assets/images/almighty.jpeg"),
      date: "May 2023 - July 2024",
      desc: "Worked as a Full Stack Software Engineer on a production mover application, delivering end-to-end features across frontend, backend, and AI-powered systems. Took ownership of building scalable user-facing functionality, real-time communication features, and intelligent services while collaborating closely with cross-functional team members.",
      descBullets: [
        "Built responsive and interactive frontend features using React with efficient state management and smooth user navigation",
        "Designed and implemented scalable backend APIs using Node.js, Express, and PostgreSQL",
        "Developed an AI-powered chatbot using the OpenAI API and optimized response latency using socket-based communication",
        "Implemented real-time messaging and voice-to-text functionality to improve usability and accessibility",
        "Integrated vector-based search using pgvector to enable personalized and context-aware responses"
      ]
    },
    {
      role: "Student Front-End Developer",
      company: "Empyreal Infotech",
      companylogo: require("./assets/images/emplogo1.png"),
      date: "May 2022 - July 2022",
      desc: "Worked as a Front-End Developer, focusing on building interactive and reliable web applications. Took ownership of implementing robust navigation, secure data handling, and seamless state management while collaborating with the backend and ensuring high-quality user experiences.",
      descBullets: [
        "Developed responsive UI components using React, with efficient state management using Redux",
        "Implemented routing and navigation improvements with React Router to enhance user experience",
        "Built input validation mechanisms to ensure accurate data submission and prevent malicious inputs",
        "Integrated APIs for dynamic data rendering and maintained synchronization with frontend state"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle:
    "Projects built from curiosity and a passion for solving real-world problem",
  projects: [
    {
      image: require("./assets/images/optimalpay.png"),
      projectName: "OptimalPay Backend (ExpressJS)",
      projectDesc:
        "OptimalPay is an algorithm-driven debt optimization system that evaluates multiple repayment strategies using priority-based categorization, O(log n) priority queue operations, and adaptive planning with detailed monthly projections.",
      github: "https://github.com/divyesh-rathod/OptimalPay-Backend"
    },
    {
      image: require("./assets/images/smartnews.png"),
      projectName: "Smart News Backend (Python FastAPI)",
      projectDesc:
        "This ML pipeline transforms raw news articles into personalized recommendations through a multi-stage process involving web scraping, text processing, embedding generation, vector search, and neural reranking.",
      github: "https://github.com/divyesh-rathod/Smart-News-Backend"
    },
    {
      image: require("./assets/images/packetpluse.png"),
      projectName: "PacketPulse (C++)",
      projectDesc:
        "Discrete-event network simulator modeling an M/M/1/K queue with Poisson arrivals, exponential service, finite buffers, round-robin scheduling, and performance metrics including delay and drop probability.",
      github: "https://github.com/divyesh-rathod/PacketPulse"
    },

    {
      image: require("./assets/images/warehouse simulation.png"),
      projectName: "WareHouse Simulation (C++)",
      projectDesc:
        "Analyzing real-world operational bottlenecks, I built a discrete-event warehouse simulation that models multi-stage order processing, worker constraints, priority-based scheduling, and tracks KPIs like utilization, queue length, wait time, and overall throughput.",
      github: "https://github.com/divyesh-rathod/WareHouse-Simulation"
    },
    {
      image: require("./assets/images/banking system.png"),
      projectName: "Banking System (Python-Django)",
      projectDesc:
        "Designing secure distributed systems, I built a client-server banking system using Python and Flask with SSL-encrypted communication, role-based access control, secure password hashing, transactional workflows, and an admin panel for system monitoring",
      github: "https://github.com/divyesh-rathod/banking_system_python"
    },
    {
      image: require("./assets/images/smartnews.png"),
      projectName: "Smart News Frontend (React - TypeScript) ",
      projectDesc:
        "Smart News Frontend is a React TypeScript application delivering AI-powered personalized news with real-time recommendations, secure authentication, infinite scrolling, and optimized state management using Redux Toolkit.",
      github: "https://github.com/divyesh-rathod/Smart-News-Backend"
    },
    {
      image: require("./assets/images/transformer.png"),
      projectName: "Transformer (Pytorch) ",
      projectDesc:
        "Demystifying large language models, I built a transformer from scratch in PyTorch by reverse-engineering “Attention Is All You Need”, applying it to an English-to-Italian translation system trained on the OPUS Books dataset.",
      github: "https://github.com/divyesh-rathod/transformer"
    },
    {
      image: require("./assets/images/api backend java.png"),
      projectName: "Ecommerce Backend (Java SpringBoot)",
      projectDesc:
        "Designing scalable backend services, I built ecommerce REST APIs with Spring Boot and Java 21, integrating PostgreSQL, file uploads, and test-driven development using JUnit and Cucumber.",
      github: "https://github.com/divyesh-rathod/Ecommerce-Backend-with-Testing"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Github Foundation",
      subtitle:
        "Earned GitHub Foundations certification, validating proficiency in Git, GitHub collaboration workflows, issue tracking, pull requests, and repository management.",
      image: require("./assets/images/github.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/f1eb25b0-da70-4b0c-ac74-45b9f7e8de8e/linked_in_profile"
        }
      ]
    },
    {
      title: "How Google does Machine Learning",
      subtitle:
        "Completed the “How Google Does Machine Learning” Coursera course, gaining insights into practical ML workflows, model deployment, and real-world applications.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/certificate/UXS7S6PTEKGL"
        }
      ]
    },

    {
      title: "Launching into Machine Learning",
      subtitle:
        "Completed “Launching into Machine Learning” by Google, gaining hands-on experience with foundational ML concepts, model building, and practical applications",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.coursera.org/account/accomplishments/certificate/FE2XS4SNETFJ"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Looking to connect! Whether it’s a project, a hello,My inbox is open for all,and I am also looking for co-op opportunities for Summer 2026.",
  email_address: "divyeshrathod096@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
